import { TRANSITION_MS } from '@/constants/timing';

// Flyout layout constants
export const FLYOUT_WIDTH = '1200px';
export const FLYOUT_HEADER_PADDING = 3;
export const FLYOUT_CONTENT_PADDING_X = 3;
export const FLYOUT_CONTENT_PADDING_Y = 4;
export const FLYOUT_CONTENT_GAP = 5;

// Animation constants
export const FLYOUT_TRANSITION_DURATION = TRANSITION_MS.DEFAULT;

// Common styling
export const FLYOUT_BORDER_COLOR = 'rgba(0,0,0,0.12)';
export const FLYOUT_HEADER_BORDER = 1;

// Typography constants
export const FLYOUT_TITLE_FONT_SIZE = 20;
export const FLYOUT_TITLE_FONT_WEIGHT = 600;
export const FLYOUT_TITLE_LINE_HEIGHT = '32px';

export const FLYOUT_SUBTITLE_FONT_SIZE = 12;
export const FLYOUT_SUBTITLE_FONT_WEIGHT = 400;
export const FLYOUT_SUBTITLE_LINE_HEIGHT = '32px';

export const FLYOUT_FIELD_TITLE_FONT_SIZE = 16;
export const FLYOUT_FIELD_TITLE_FONT_WEIGHT = 600;

export const FLYOUT_FIELD_VALUE_FONT_SIZE = 14;
export const FLYOUT_FIELD_VALUE_FONT_WEIGHT = 400;
export const FLYOUT_FIELD_VALUE_LINE_HEIGHT = '24px';
